<template>
  <v-card>
    <v-card-title>
      {{ trans('guest.guestData') }}
    </v-card-title>

    <v-card-text>
      <form-input
        :label="trans('guest.name')"
        cols="3"
        readonly
      >
        <template v-slot:input>
          <guest-name :value="guest"/>
        </template>
      </form-input>

      <form-input
        v-if="showId"
        :label="trans('guest.id')"
        cols="3"
        v-model="guest.id"
        readonly
      >
      </form-input>

      <form-input
        v-if="canSeeAllDetails"
        :label="trans('guest.address')"
        cols="3"
        readonly
      >
        <template v-slot:input>
          <template v-if="guest">
            <span>{{guest.street}}</span><br>
            <span>{{guest.zipcode}} {{guest.city}}</span><br>
            <span>{{guest.country}}</span>
          </template>
        </template>
      </form-input>

      <form-input
        :label="trans('guest.email')"
        :value="guest ? guest.email : ''"
        cols="3"
        readonly
      />

      <form-input
        :label="trans('guest.phone')"
        :value="guest ? guest.phone : ''"
        cols="3"
        readonly
      />

      <form-input
        :label="trans('guest.mobilePhone')"
        :value="guest ? guest.mobilePhone : ''"
        cols="3"
        readonly
      />

      <form-input
        v-if="canSeeAllDetails"
        :label="trans('guest.receivePromotionMails')"
        :value="receivePromotionMailsText"
        cols="3"
        readonly
      />
    </v-card-text>
  </v-card>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import {MainUtils} from '@/utils/main-utils';
import FormInput from '@/components/FormInput';
import GuestName from '@/components/GuestName';

export default {
  name: 'GuestCard',
  components: {GuestName, FormInput},
  mixins: [
    LocaleUtils,
    MainUtils
  ],
  props: {
    guest: {
      type: Object,
      required: true
    },
    showId: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canSeeAllDetails() {
      return this.hasAnyPermission('BOOKING_VIEW_DETAILS');
    },
    receivePromotionMailsText() {
      const value = this.guest?.receivePromotionMails;
      if(value === true) {
        return this.trans('general.yes');
      }
      if(value === false) {
        return this.trans('general.no');
      }
      return this.trans('general.nothingGiven');
    }
  }
}
</script>

<style scoped>

</style>
